import { EMAIL_REGEX, PASSWORD_REGEX, PHONE_NUMBER_REGEX } from "@energyx-dev/energyx-ui";

export const RULES_REQUIERD = {
  required: {
    value: true,
    message: "필수 입력 항목입니다.",
  },
};

export const EN_RULES_REQUIERD = {
  required: {
    value: true,
    message: "Please complete this required field.",
  },
};

export const EN_RULES_PATTERN_PHONE_NUMBER = {
  pattern: {
    value: PHONE_NUMBER_REGEX,
    message: "Please confirm your mobile phone number.",
  },
};
export const EN_RULES_PATTERN_EMAIL = {
  pattern: {
    value: EMAIL_REGEX,
    message: "Please confirm your e-mail address.",
  },
};
export const EN_RULES_PHONE_NUMBER_MAX_LENGTH = {
  maxLength: {
    value: 13,
    message: "",
  },
};
export const EN_RULES_PATTERN_PASSWORD = {
  pattern: {
    value: PASSWORD_REGEX,
    message: "At least 6 characters using a combination of alphanumeric characters.",
  },
};
